import { Trans } from "react-i18next";

const DownloadGuide = ({ handleDownloadGuide, helpText }) => {
  return (
    <Trans i18nKey={helpText}>
      <p className="subheading__text-black" onClick={handleDownloadGuide}>
        <a
          style={{ cursor: "pointer" }}
          className="subheading__primary-one linkStyle"
        />
      </p>
    </Trans>
  );
};

export default DownloadGuide;
